import { useOptimizedRecord } from '@/shared/hooks/useOptimizedQuery'

import type { LevelDetail } from '../types'

/**
 * Detalhe de pontuação do aluno num nível (adquirido/total + desafios pontuáveis
 * com flag de acerto). Alimenta o modal aberto ao clicar numa linha de Nível.
 */
export function useLevelDetails(levelId: number | null) {
  return useOptimizedRecord<LevelDetail>({
    path: '/user/content_history/level_details',
    params: levelId != null ? { level_id: levelId } : undefined,
    enabled: levelId != null,
    skipInitialData: true
  })
}
